const house_sec1_part2Object = payload => {
  return {
    type: "housesec1part2",
    payload
  };
};

export default house_sec1_part2Object;
